import styles from "./BareButton.module.scss";

interface BareButtonProps {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  handleClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const BareButton = ({
  children,
  className = "",
  dataTestId,
  disabled = false,
  handleClick,
}: BareButtonProps) => {
  return (
    <button
      {...(dataTestId ? { "data-testid": dataTestId } : {})}
      {...(disabled ? { disabled: true } : {})}
      onClick={handleClick}
      className={`${styles["pt-bare-button"]} ${className}`}
    >
      {children}
    </button>
  );
};
